import './NewsShortCut.css';
import ShortNewsDisplayer from '../ShortNewsDisplayer/ShortNewsDisplayer';

const NewsShortCut = () => {

    
    return (
        <div id='NewsShortCutMainContainer'>
           <p className='SectionTitle'>Aktualności</p>
             <ShortNewsDisplayer />
        </div>
    )
}

export default NewsShortCut;